import {exportCsv} from "../paiements/functions";
import {removeFieldType} from "../../editors/WebEditor/formPlugins";
import ApiService from "../../../services/ApiService"
import moment from "moment"
import "moment/locale/fr"
import {ASSET_BASE_URL} from "../../../configs/AppConfig";
import {checkPermissions} from "../../../components/permissions/functions";
import {notification} from "antd";
import IntlMessage from "../../../components/util-components/IntlMessage";
import React from "react";
import {HDate} from "@hebcal/core";
import Hebcal from "../../../hebcal";

import {t} from "@lingui/core/macro"

export function getStates() {
    return [
        {text: t`Soumis`, value: "SUBMIT", color: "orange"},
        {text: t`Validé`, value: "VALIDE", color: "green"},
        {text: t`Invalidé`, value: "INVALIDE", color: "red"},
        {text: t`Archivé`, value: "ARCHIVED", color: "blue"},
    ]
}


export async function exportData(state,params=null) {
    if (!checkPermissions(["submit.export"])) {
        notification.error({
            message: <IntlMessage id="access.error"/>
        })
        return false
    }

    if(!params){
        params = {
            filters: {...state.filters},
            sorter: state.sorter,
            search: state.search,
            calendarFilters: state.calendarFilters
        }

        if (state.range) {
            params.filters.range = {
                debut: new Date(state.range[0].format("YYYY-MM-DD")),
                fin: new Date(state.range[1].format("YYYY-MM-DD")),
            }
        } else {
            params.filters.range = null
        }
    }

    params.all = true

    var res = await ApiService.post("/forms_submit/" + state.form.id, params)
    const data = res.data
    const products = res.products


    var contactType = "NONE"
    data.forEach(i => {
        var keys = Object.keys(i.data)
        if (keys.some(i => i === "identity") && contactType === "NONE") {
            contactType = "SIMPLE"
        }
        if (keys.some(i => i === "identity") && i.data["identity"].adresse) {
            contactType = "FULL"
        }
    })


    var headers = [t`ID`, t`_date soumission`, t`_etat`]
    if (state.form.type === "COMPLEX") {
        headers.push(t`_montant réglé`, t`_montant restant`)
    }

    if (contactType !== "NONE") {
        headers.push(t`Contact Nom`, t`Contact Prénom`, t`Contact Email`, t`Contact Téléphone`)
    }
    if (contactType === "FULL") {
        headers.push(t`Contact Adresse`, t`Contact Code Postal`, t`Contact Ville`)
    }
    data.forEach(i => {
        var keys = Object.keys(i.data)
        keys.forEach(k => {
            let key = k

            if (key.includes("_quantity")) {
                const product = products.find(i => i.id === key.replace("_quantity", ""))
                if (product) {
                    key = product.label
                } else {
                    key = null
                }
            }

            if (key && key.match("[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}")) { // PRODUCT DETAIL
                key = null
            }

            if (key && key === "identity") { // IDENTITY
                key = null
            }

            if (key && !headers.includes(removeFieldType(key)) && !key.startsWith("[ID]")) {
                headers.push(removeFieldType(key))
            }
        })
    })

    var body = data.map((item) => {

        var data = []
        for (var h of headers) {
            switch (h) {
                case t`ID`:
                    data.push(item.id)
                    break;
                case t`_date soumission`:
                    data.push(moment(item.datetime).format("DD MMMM YYYY à HH:mm"))
                    break;
                case t`_etat`:
                    data.push(item.state)
                    break;
                case t`_montant réglé`:
                    data.push(item.payed / 100)
                    break;
                case t`_montant restant`:
                    data.push(item.reste / 100)
                    break;

                case 'identity':
                    break
                case t`Contact Nom`:
                    data.push(item.data?.identity?.nom)
                    break;
                case t`Contact Prénom`:
                    data.push(item.data?.identity?.prenom)
                    break;
                case t`Contact Email`:
                    data.push(item.data?.identity?.email)
                    break;
                case t`Contact Téléphone`:
                    data.push(item.data?.identity?.tel)
                    break;
                case t`Contact Adresse`:
                    data.push(item.data?.identity?.adresse)
                    break;
                case t`Contact Code Postal`:
                    data.push(item.data?.identity?.postal)
                    break;
                case t`Contact Ville`:
                    data.push(item.data?.identity?.ville)
                    break;
                default:
                    const key = Object.keys(item.data).find(i => removeFieldType(i) === h)
                    if (!key) {
                        const product = products.find(i => i.label === h)
                        if (product) {
                            data.push(item.data[product.id + "_quantity"])
                        } else {
                            data.push("")
                        }
                    } else {
                        const value = item.data[key]
                        if (value === null || value === undefined) {
                            data.push("")
                        } else if (Array.isArray(value)) {
                            data.push(value.map(i => formatValueExport(key, i)).join(","))
                        } else {
                            data.push(formatValueExport(key, value))
                        }
                    }

            }
        }
        return data
    })

    exportCsv(
        "export_formulaire_" + state.form.title + ".csv",
        headers,
        body.filter(row => row !== false)
    )
}

export async function exportProducts(state,params=null) {

    if (!checkPermissions(["submit.export"])) {
        notification.error({
            message: <IntlMessage id="access.error"/>
        })
        return false
    }

    if(!params){
        params = {
            filters: {...state.filters},
            sorter: state.sorter,
            search: state.search,
            calendarFilters: state.calendarFilters
        }

        if (state.range) {
            params.filters.range = {
                debut: new Date(state.range[0].format("YYYY-MM-DD")),
                fin: new Date(state.range[1].format("YYYY-MM-DD")),
            }
        } else {
            params.filters.range = null
        }
    }

    params.all = true

    var res = await ApiService.post("/forms_submit/" + state.form.id, params)
    const products = res.products
    let data = []

    for (var d of res.data) {
        var objectData = {...d}
        var keys = Object.keys(objectData.data)
        var submitData = {}
        for (let k of keys.filter(i => !i.match("[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}"))) { // SIMPLE DATA
            submitData[k] = objectData.data[k]
        }

        for (let k of keys.filter(i => i.includes("_quantity"))) { // QUANTITY

            let localData = {...objectData}
            let localSubmit = {...submitData}

            const productId = k.replace("_quantity", "")
            let product = products.find(i => i.id === productId)

            if (product) {

                for (let j = 0; j < objectData.data[k]; j++) {

                    localSubmit[t`_produit`] = product.label

                    const compProduct = objectData.data[productId]
                    if (compProduct) {
                        let pd = compProduct[j]
                        const clocalData = {...localData}
                        const clocalSubmit = {...localSubmit}

                        for (let pdk of Object.keys(pd)) {
                            clocalSubmit[pdk + "_(CP)"] = pd[pdk]
                        }
                        clocalData.data = clocalSubmit
                        data.push(clocalData)

                    } else {
                        localData.data = localSubmit
                        data.push(localData)
                    }
                }
            }
        }
    }


    var contactType = "NONE"
    data.forEach(i => {
        var keys = Object.keys(i.data)
        if (keys.some(i => i === "identity") && contactType === "NONE") {
            contactType = "SIMPLE"
        }
        if (keys.some(i => i === "identity") && i.data["identity"].adresse) {
            contactType = "FULL"
        }
    })


    var headers = [t`ID`, t`_date soumission`, t`_etat`]
    if (contactType !== "NONE") {
        headers.push(t`Contact Nom`, t`Contact Prénom`, t`Contact Email`, t`Contact Téléphone`)
    }
    if (contactType === "FULL") {
        headers.push(t`Contact Adresse`, t`Contact Code Postal`, t`Contact Ville`)
    }
    data.forEach(i => {

        var keys = Object.keys(i.data)
        keys.forEach(k => {
            let key = k

            if (key && !headers.includes(removeFieldType(key)) && key !== "identity") {
                headers.push(removeFieldType(key))
            }
        })
    })

    var body = data.map((item) => {

        var data = []
        for (var h of headers) {
            switch (h) {
                case t`ID`:
                    data.push(item.id)
                    break;
                case t`_date soumission`:
                    data.push(moment(item.datetime).format("DD MMMM YYYY à HH:mm"))
                    break;
                case t`_etat`:
                    data.push(item.state)
                    break;
                case 'identity':
                    break
                case t`Contact Nom`:
                    data.push(item.data?.identity?.nom)
                    break;
                case t`Contact Prénom`:
                    data.push(item.data?.identity?.prenom)
                    break;
                case t`Contact Email`:
                    data.push(item.data?.identity?.email)
                    break;
                case t`Contact Téléphone`:
                    data.push(item.data?.identity?.tel)
                    break;
                case t`Contact Adresse`:
                    data.push(item.data?.identity?.adresse)
                    break;
                case t`Contact Code Postal`:
                    data.push(item.data?.identity?.postal)
                    break;
                case t`Contact Ville`:
                    data.push(item.data?.identity?.ville)
                    break;
                default:
                    const key = Object.keys(item.data).find(i => removeFieldType(i) === h)
                    if (!key) {
                        data.push("")
                    } else {
                        const value = item.data[key]
                        if (value === null || value === undefined) {
                            data.push("")
                        } else if (Array.isArray(value)) {
                            data.push(value.map(i => formatValueExport(key, i)).join(","))
                        } else {
                            data.push(formatValueExport(key, value))
                        }
                    }

            }
        }
        return data
    })

    exportCsv(
        "export_formulaire_produits_" + state.form.title + ".csv",
        headers,
        body.filter(row => row !== false)
    )
}

export function formatValueExport(key, value) {
    if (key.startsWith("[CHECKBOX]_")) {
        return value ? t`Oui` : t`Non`
    }

    if (key.startsWith("[DATE]_")) {
        return moment(value).format("DD MMMM YYYY")
    }

    if (key.startsWith("[DATETIME]_") || key.startsWith("[ANNIV]_") || key.startsWith("[CALENDAR]_")) {
        return moment(value).format("DD MMMM YYYY à HH:mm")
    }

    if (key.startsWith("[YEAR]_")) {
        return moment(value).format("YYYY")
    }

    if (key.startsWith("[MONTH]_")) {
        return moment(value).format("MMMM YYYY")
    }

    if (key.startsWith("[TIME]_")) {
        return moment(value).format("HH:mm")
    }

    if (key.startsWith("[DOCUMENT]_") || key.startsWith("[DOCUMENT_MULTI]_")) {
        return ASSET_BASE_URL + "/" + value.doc
    }

    if (key.startsWith("[CONTACT]_")) {
        return (value.prenom + " " + value.nom + " " + value.tel + " " + value.email).replaceAll("undefined", "").trim()
    }

    if (key.startsWith("[CHILD]_")) {
        return (value.prenom + " " + value.nom + " " + new Date(value.ddn).toLocaleDateString()+" "+ getHebddn(value.ddn)).replaceAll("undefined", "").trim()
    }

    if (key.startsWith("[HAZKARA]_")) {
        return (value.prenom + " " + value.nom + " " + new Date(value.deceasedDate).toLocaleDateString()).replaceAll("undefined", "").trim()
    }

    if (typeof value === "string") {
        value = value.replaceAll("\n", " ").replaceAll("\t", " ").replaceAll("\r", " ")
    }

    return value || ""
}


function getHebddn(ddn){

    if(!ddn){
        return "-"
    }

    let org = null
    try {
        org = JSON.parse(localStorage.getItem("ORG"))
    } catch (e) {
    }

    var hdate = new HDate(new Date(ddn))
    if (org) {
        const hebcal = new Hebcal(org, new Date(), org.lat, org.long)
        hdate = hebcal.getAnnivHDate(new Date(ddn))
        console.log(hdate.toLocaleString())
    }
    return hdate.getDate() + "/" + hdate.getMonthName() + "/" + hdate.getFullYear()
}
